import { userActions, userReducer } from '@engineering11/user-web'
import * as userEffects from './user/user.effects'
import { userSelectors } from './user/user.selectors'

export { userActions, userEffects, userReducer, userSelectors }

export const sharedEffects = { ...userEffects }
export const sharedSelectors = { ...userSelectors }
export const sharedReducers = { user: userReducer }
